import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";
import { CreateFlagCard } from "./featureFlags/CreateFlagCard";
import { FlagRow } from "./featureFlags/FlagRow";
import { FlagStats, RolloutPreview } from "./featureFlags/RolloutPreview";
import { useFeatureFlagsAdmin } from "./featureFlags/useFeatureFlagsAdmin";

export function FeatureFlagsTab() {
  const admin = useFeatureFlagsAdmin();
  const {
    featureFlags, flagsLoading, flagSaving, flagActivity, featureFlagStats,
    newFlagKey, setNewFlagKey, newFlagName, setNewFlagName,
    newFlagDescription, setNewFlagDescription, createFlag,
  } = admin;

  return (
    <div className="space-y-4">
      <RolloutPreview featureFlags={featureFlags} />
      <FlagStats stats={featureFlagStats} />
      <CreateFlagCard
        newFlagKey={newFlagKey}
        setNewFlagKey={setNewFlagKey}
        newFlagName={newFlagName}
        setNewFlagName={setNewFlagName}
        newFlagDescription={newFlagDescription}
        setNewFlagDescription={setNewFlagDescription}
        flagSaving={flagSaving}
        isCreating={flagActivity.create}
        onCreate={createFlag}
      />

      <Card className="shadow-soft">
        <CardHeader><CardTitle>Existing flags</CardTitle></CardHeader>
        <CardContent className="space-y-4">
          {flagsLoading && (
            <div className="space-y-3">
              {Array.from({ length: 2 }).map((_, i) => <Skeleton key={i} className="h-32 w-full" />)}
            </div>
          )}
          {!flagsLoading && featureFlags.length === 0 && (
            <p className="text-sm text-muted-foreground">No feature flags yet. Create one above to get started.</p>
          )}
          {featureFlags.map((flag) => (
            <FlagRow key={flag.id} flag={flag} admin={admin} />
          ))}
        </CardContent>
      </Card>
    </div>
  );
}
